import React from 'react';
import { PricedUpMainLogoWrapper, PricedUpMainLogo } from './pricedup.style';

export const PricedUpLogotype = (): JSX.Element => (
    <PricedUpMainLogoWrapper>
        <PricedUpMainLogo />
    </PricedUpMainLogoWrapper>
);
